import {
  TAG_MULT,
  TAG_ARITHMETIC,
  TAG_FRACTION,
  TAG_NEW,
  TAG_ADDITION,
  TAG_DIVISION,
  TAG_NUMBERS_AND_QUANTITIES,
  TAG_STATISTICS,
  TAG_GEOMETRY,
} from '~/games/constants/games.const'

export interface Tag {
  id: number
  name: GameTagName
  bg: string
  color: string
  iconName?: string
}

export type GameTagName =
  | (typeof TAG_MULT)['name']
  | (typeof TAG_ARITHMETIC)['name']
  | (typeof TAG_FRACTION)['name']
  | (typeof TAG_NEW)['name']
  | (typeof TAG_ADDITION)['name']
  | (typeof TAG_DIVISION)['name']
  | (typeof TAG_NUMBERS_AND_QUANTITIES)['name']
  | (typeof TAG_STATISTICS)['name']
  | (typeof TAG_GEOMETRY)['name']

export interface ShipLocation {
  shipPosX: number
  shipPosZ: number
  shipRotation: number
  updateTime: number
}
export interface CompletedLevel {
  [key: string]: {
    boxesDestroyed: number
    boxesLifted: number
    date: number
    goldBoxesGotten: boolean[]
  }
}
export interface CraneGameLevelData {
  levelName: string
  boxesDestroyed: number
  boxesLifted: number
  date: number
  goldBoxesGotten: boolean[]
  specialBoxCount: number
}

export interface ShipState {
  x: number
  z: number
  rotation: number
}

export interface GameRewards {
  awardPoints: number
  kudosOrbs?: number
  gemType?: 'red'
  gemCount?: number
  eventFeature?: string
  eventType?: string
}

export enum TabClick {
  HOME = 'Home',
  AVATAR = 'Avatar',
  DRAGON = 'Dragon',
  SHOP = 'Shop',
}
